import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SupportRequestComponent } from './support-request.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreInputsModule } from '@tmhcc-ng-lib/framwork/core-inputs';

const routes: Routes = [
  {
    path: '',
    component: SupportRequestComponent
  },  
  {
    path: ':value',
    component: SupportRequestComponent
  }
];

@NgModule({
  declarations: [SupportRequestComponent],
  imports: [
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    CoreInputsModule,
    CommonModule
  ],
  exports: [RouterModule],
  providers: []
})
export class SupportRequestModule {}
